module.exports = __webpack_public_path__ + "static/media/doceria.5c1531e3.svg";